import type { Template } from "@/types";

export const PO_03_H0_V3: Template[] = [
    {
        id: "po-03-h0v3-01",
        name: "PO 01 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_01.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 118, y: 179, width: 334, height: 536, rotation: 0, imageRotation: 0 },
            { id: "2", x: 459, y: 179, width: 334, height: 536, rotation: 0, imageRotation: 0 },
            { id: "3", x: 801, y: 179, width: 334, height: 536, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-02",
        name: "PO 02 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_02.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 50, y: 143, width: 379, height: 607, rotation: 0, imageRotation: 0 },
            { id: "2", x: 436, y: 143, width: 379, height: 607, rotation: 0, imageRotation: 0 },
            { id: "3", x: 823, y: 143, width: 379, height: 607, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-03",
        name: "PO 03 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_03.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 0, y: 143, width: 413, height: 607, rotation: 0, imageRotation: 0 },
            { id: "2", x: 420, y: 143, width: 413, height: 607, rotation: 0, imageRotation: 0 },
            { id: "3", x: 840, y: 143, width: 412, height: 607, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-04",
        name: "PO 04 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_04.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 34, y: 179, width: 334, height: 536, rotation: 0, imageRotation: 0 },
            { id: "2", x: 375, y: 45, width: 502, height: 804, rotation: 0, imageRotation: 0 },
            { id: "3", x: 885, y: 179, width: 334, height: 536, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-05",
        name: "PO 05 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_05.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 35, y: 0, width: 556, height: 894, rotation: 0, imageRotation: 0 },
            { id: "2", x: 669, y: 236, width: 262, height: 422, rotation: 0, imageRotation: 0 },
            { id: "3", x: 939, y: 236, width: 262, height: 422, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-06",
        name: "PO 06 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_06.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 182, y: 236, width: 262, height: 422, rotation: 0, imageRotation: 0 },
            { id: "2", x: 668, y: 236, width: 263, height: 422, rotation: 0, imageRotation: 0 },
            { id: "3", x: 939, y: 236, width: 262, height: 422, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-07",
        name: "PO 07 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_07.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 182, y: 0, width: 287, height: 443, rotation: 0, imageRotation: 0 },
            { id: "2", x: 182, y: 451, width: 287, height: 443, rotation: 0, imageRotation: 0 },
            { id: "3", x: 703, y: 69, width: 470, height: 755, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-08",
        name: "PO 08 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_08.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 269, y: 72, width: 474, height: 750, rotation: 0, imageRotation: 0 },
            { id: "2", x: 750, y: 72, width: 233, height: 371, rotation: 0, imageRotation: 0 },
            { id: "3", x: 750, y: 451, width: 233, height: 371, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-09",
        name: "PO 09 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_09.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 35, y: 235, width: 274, height: 423, rotation: 0, imageRotation: 0 },
            { id: "2", x: 316, y: 235, width: 273, height: 423, rotation: 0, imageRotation: 0 },
            { id: "3", x: 703, y: 69, width: 470, height: 755, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h0v3-10",
        name: "PO 10 - H0V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h0_v3_10.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 625, height: 895, rotation: 0, imageRotation: 0 },
            { id: "2", x: 688, y: 259, width: 244, height: 377, rotation: 0, imageRotation: 0 },
            { id: "3", x: 939, y: 259, width: 243, height: 377, rotation: 0, imageRotation: 0 }
        ],
    }
];